import { isEmpty, uniq } from 'lodash/fp';

import {
    CONSTANT_VACCINATION_ID_KEY,
    EXPANDED_WOLBACHIA_ID_KEY,
    FORECAST_SCENARIO_ID_KEY,
    OUTCOME_ID_KEY,
} from '@portal/common/models/data-key';
import { DataGranularity } from '@portal/common/types';

import { FORECAST_SCENARIO_SPLIT_MAP } from '../../constants/dengue-scenarios';

/**
 * Patches dengue granularity by adding constant vaccination and expanded Wolbachia filters
 * @param refinedGranularity - The refined granularity object to be modified
 * @param granularity - The full granularity object
 */
const patchDengueGranularity = (
    refinedGranularity: DataGranularity,
    granularity: DataGranularity
) => {
    if (!refinedGranularity || !granularity) {
        console.warn('Invalid parameters passed to patchDengueGranularity');
        return;
    }

    refinedGranularity[OUTCOME_ID_KEY] = [...(granularity[OUTCOME_ID_KEY] || [])] as number[];

    const forecastScenarios = refinedGranularity[FORECAST_SCENARIO_ID_KEY] || [];

    if (isEmpty(forecastScenarios)) {
        return;
    }

    const constantVaccinations = uniq(
        forecastScenarios
            .map((value: number | string) => {
                const numValue = typeof value === 'string' ? parseInt(value, 10) : value;
                return FORECAST_SCENARIO_SPLIT_MAP[numValue]?.[CONSTANT_VACCINATION_ID_KEY];
            })
            .filter((value): value is number => value !== undefined)
    );

    const expandedWolbachias = uniq(
        forecastScenarios
            .map((value: number | string) => {
                const numValue = typeof value === 'string' ? parseInt(value, 10) : value;
                return FORECAST_SCENARIO_SPLIT_MAP[numValue]?.[EXPANDED_WOLBACHIA_ID_KEY];
            })
            .filter((value): value is number => value !== undefined)
    );

    refinedGranularity[CONSTANT_VACCINATION_ID_KEY] = constantVaccinations;
    refinedGranularity[EXPANDED_WOLBACHIA_ID_KEY] = expandedWolbachias;
};

export default patchDengueGranularity;
